import { render, staticRenderFns } from "./ArrowRightIcon.vue?vue&type=template&id=8baca072&scoped=true&"
import script from "./ArrowRightIcon.vue?vue&type=script&lang=ts&"
export * from "./ArrowRightIcon.vue?vue&type=script&lang=ts&"
import style0 from "./ArrowRightIcon.vue?vue&type=style&index=0&id=8baca072&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8baca072",
  null
  
)

export default component.exports